import { FileParameter } from '@lmt/shared-types';
import { GlobalState } from '../../store/types';

export function getImportFile(state: GlobalState): FileParameter | undefined {
  return state.pts.file;
}

export function getPdfFile(
  state: GlobalState,
): FileParameter | undefined | null {
  return state.pts.pdfFile;
}
